import React, { useRef } from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface CustomValueInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  customValuePlaceholder: string;
  customValueButtonLabel: string;
  onSubmit: () => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement | HTMLButtonElement>, isInput: boolean) => void;
}

export const CustomValueInput: React.FC<CustomValueInputProps> = ({
  inputValue,
  setInputValue,
  customValuePlaceholder,
  customValueButtonLabel,
  onSubmit,
  handleKeyDown,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <form
      className="p-3"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <Input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={customValuePlaceholder}
        className="mb-2"
        onKeyDown={(e) => handleKeyDown(e, true)}
      />
      <Button
        type="submit"
        variant="dark"
        className="w-full"
        onKeyDown={(e) => handleKeyDown(e, false)}
        data-custom-submit-button
      >
        {customValueButtonLabel}
      </Button>
    </form>
  );
};
